import { render, staticRenderFns } from "./booklet-configurator.vue?vue&type=template&id=5efb1e68&scoped=true"
import script from "./booklet-configurator.vue?vue&type=script&lang=ts"
export * from "./booklet-configurator.vue?vue&type=script&lang=ts"
import style0 from "./booklet-configurator.vue?vue&type=style&index=0&id=5efb1e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb1e68",
  null
  
)

export default component.exports